/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import { API_ROOT } from 'config/hosts';
import { get } from './request';

interface UserInfo {
  privilegeList: string[];
  [key: string]: any;
}

class User {
  userPromise: null | Promise<UserInfo> = null;

  init = () => {
    if (!this.userPromise) {
      this.userPromise = get(`${API_ROOT}/usermaster/identity/nrrp.json`);
    }
    return this.userPromise;
  };

  logout = async () => {
    const data = await get(`${API_ROOT}/usermaster/logout.json`);
    if (data === 'Success') {
      window.location.reload();
    }
  };
}

const user = new User();

export default user;
